import React, { useState } from 'react';
import { Button, Input, Card } from '../components/ui';
import { authApi, setToken } from '../api/client';
import type { User } from '../api/types';

interface Props {
  onRegister: (user: User, token: string) => void;
  onGoLogin: () => void;
}

export const RegisterPage: React.FC<Props> = ({ onRegister, onGoLogin }) => {
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await authApi.register(email, password, displayName);
      if (res.ok) {
        setToken(res.data.token);
        onRegister(res.data.user, res.data.token);
      } else {
        setError(res.error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--bg-secondary)',
      }}
    >
      <div style={{ width: '100%', maxWidth: 400, padding: '0 16px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: 'var(--primary)',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              fontWeight: 800,
              fontSize: 20,
              marginBottom: 12,
            }}
          >
            BLS
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700 }}>Create account</h1>
          <p style={{ color: 'var(--text-secondary)', marginTop: 4 }}>
            Join better_local_slock
          </p>
        </div>

        <Card>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <Input
              label="Display Name"
              value={displayName}
              onChange={(e) => setDisplayName(e.target.value)}
              placeholder="Alice Chen"
              required
            />
            <Input
              label="Email"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
            {error && (
              <div
                style={{
                  background: '#FEE2E2',
                  color: '#991B1B',
                  padding: '8px 12px',
                  borderRadius: 'var(--radius)',
                  fontSize: 13,
                }}
              >
                {error}
              </div>
            )}
            <Button type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
              {loading ? 'Creating account…' : 'Create account'}
            </Button>
          </form>
        </Card>

        <p style={{ textAlign: 'center', marginTop: 16, fontSize: 13, color: 'var(--text-secondary)' }}>
          Already have an account?{' '}
          <button
            onClick={onGoLogin}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--primary)', fontWeight: 600 }}
          >
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
};
